<template>
  <div class="vg_wrapper">
    <el-card>
      <publicTips></publicTips>
      <div class="vd_search_group">
        <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="120px" size="min" @keyup.enter.native="getSmplsNow()">
          <el-row>
            <el-col :md="8">
              <el-form-item label="委托单号:">
                <el-input v-model.trim="searchForm.requ_no" clearable placeholder="请填写委托单号" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="样品编号:">
                <el-input v-model.trim="searchForm.smpl_no" clearable placeholder="请填写样品编号" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="样品名称:">
                <el-input v-model.trim="searchForm.smpl_name" clearable placeholder="请填写样品名称" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="8">
              <el-form-item label="单据状态:">
                <selectStatus ref="selectStatus" @selectStatusRow="getStatusVal"></selectStatus>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="样品类型:">
                <el-select v-model="searchForm.smpl_type" clearable filterable placeholder="请选择样品类型" size="small">
                  <el-option v-for="item in smplType" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="开版师:">
                <el-select v-model="searchForm.smpl_stff_name" clearable filterable placeholder="请选择开版师" size="small">
                  <el-option v-for="item in stffType" :key="item.user_id" :label="item.stff_name" :value="item.stff_name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!--            <el-col :md="8">-->
            <!--              <el-form-item label="客户货号:">-->
            <!--                <el-input size="small" v-model.trim="searchForm.smpl_cust_no" clearable placeholder="请填写客户货号"></el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :md="8">
              <el-form-item label="更改号:">
                <el-input v-model.trim="searchForm.smpl_suffix" clearable placeholder="请填写更改号" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="邮寄状态:">
                <el-select v-model="searchForm.smpl_ship_odd" clearable filterable placeholder="请选择邮寄状态" size="small">
                  <el-option v-for="item in postList" :key="item.id" :label="item.lable" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="所属部门:">
                <el-select v-model="searchForm.belo_dept_id" clearable filterable placeholder="请选择所属部门" size="small">
                  <el-option v-for="item in deptList" :key="item.id" :label="item.param1" :value="item.param2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="8">
              <el-form-item label="实际交样时间:">
                <el-date-picker
                  v-model="searchForm.timeValue"
                  end-placeholder="结束日期"
                  range-separator="至"
                  size="small"
                  start-placeholder="开始日期"
                  style="width: 300px"
                  type="datetimerange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="打样接收人:" prop="requ_receive">
                <el-select v-model="searchForm.requ_receive" clearable filterable placeholder="请选择打样接收人" size="small">
                  <el-option v-for="item in stffType" :key="item.user_id" :label="item.stff_name" :value="item.stff_name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item label="创建时间:">
                <el-date-picker
                  v-model="searchForm.timeValue1"
                  end-placeholder="结束日期"
                  range-separator="至"
                  size="small"
                  start-placeholder="开始日期"
                  style="width: 300px"
                  type="datetimerange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24" class="vg_mb_8">
              <div style="display: flex; align-items: baseline">
                <el-button class="" icon="el-icon-search" size="small" type="primary" @click="getSmplsNow()"> 查询</el-button>
                <el-button class="vd_export" size="small" type="info" @click="buttonRefresh()"
                  ><i class="el-icon-refresh-right"></i> 刷新
                </el-button>
                <el-button :disabled="!btn.delete" size="small" type="danger" @click="doDelete()"
                  ><i class="el-icon-delete"></i> 删除
                </el-button>
                <el-button size="small" type="info" @click="getDataPrompt()"><i class="el-icon-s-order"></i> 确认邮寄状态</el-button>
                <span style="margin-left: auto">
                  <el-button class="vd_export1" size="small" type="primary" @click="jump('/AcceptOrdersAndCancelCardsStatistics')"
                    >跳转至接单销卡统计</el-button
                  >
                  打样总数量:{{ totalnum }}</span
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-dialog :title="title" :visible.sync="smplFlag" width="45%">
        <SmplEditMail :smplPropList="smplPropList" @MailCancel="MailCancel" @getSmpls="getSmpls"></SmplEditMail>
      </el-dialog>
      <el-row>
        <el-col :md="24">
          <el-table
            ref="multiTable"
            v-loading="loadFlag"
            :data="tableData"
            border
            class="vg_cursor"
            @select="selectRows"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            @select-all="selectRows"
            @row-dblclick="dbClickJp"
          >
            <el-table-column type="expand">
              <template v-slot="scope">
                <el-table v-if="scope.row.rfid" :data="scope.row.rfid" style="width: 100%">
                  <el-table-column align="center" label="开版状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.open_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.open">第{{ scope1.row.procMap.open }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.open" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.open }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="排版状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.typesetting_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.typesetting">第{{ scope1.row.procMap.typesetting }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.typesetting" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.typesetting }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="备料状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.stpr_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.stpr">第{{ scope1.row.procMap.stpr }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.stpr" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.stpr }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="复合状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.comp_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.comp">第{{ scope1.row.procMap.comp }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.comp" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.comp }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="激光状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.lase_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.lase">第{{ scope1.row.procMap.lase }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.lase" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.lase }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="手裁状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.handCut_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.handCut">第{{ scope1.row.procMap.handCut }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.handCut" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.handCut }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="印花状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.stam_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.stam">第{{ scope1.row.procMap.stam }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.stam" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.stam }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="电绣状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.embr_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.embr">第{{ scope1.row.procMap.embr }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.embr" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.embr }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="制卡状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.emcd_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.emcd">第{{ scope1.row.procMap.emcd }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.emcd" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.emcd }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="机缝状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.mase_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.mase">第{{ scope1.row.procMap.mase }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.mase" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.mase }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="手工状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.manu_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.manu">第{{ scope1.row.procMap.manu }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.manu" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.manu }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="检验状态">
                    <template v-slot="scope1">
                      <smplListRfid :numState="scope1.row.insp_status"></smplListRfid>
                      <div v-if="scope1.row.procMap && scope1.row.procMap.insp">第{{ scope1.row.procMap.insp }}步</div>
                      <div v-if="scope1.row.numberOfRepairs && scope1.row.numberOfRepairs.insp" class="vg_deep_red">
                        重做{{ scope1.row.numberOfRepairs.insp }}次
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="报价状态">
                    <template v-slot="scope1">
                      <div v-if="scope1.row.pricer_status === 1" class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/complate.png" />
                        <span class="vd_complate">已完成</span>
                      </div>
                      <div v-else class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/notpass.png" />
                        <div class="vd_notpass">未完成</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="样品确认状态">
                    <template v-slot="scope1">
                      <div v-if="scope1.row.smpl_conf_status === 1" class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/complate.png" />
                        <span class="vd_complate">已确认</span>
                      </div>
                      <div v-else class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/notpass.png" />
                        <div class="vd_notpass">未确认</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" class="vd_tenpd" label="核价状态">
                    <template v-slot="scope1">
                      <div v-if="scope1.row.quoter_status === 1" class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/complate.png" />
                        <span class="vd_complate">已完成</span>
                      </div>
                      <div v-else class="vd_tenpd">
                        <img alt="" class="vd_img" src="@/assets/image/notpass.png" />
                        <div class="vd_notpass">未完成</div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table v-else :data="tableDataList" style="width: 100%"></el-table>
              </template>
            </el-table-column>
            <el-table-column align="center" type="selection" width="48" />
            <el-table-column align="center" label="状态" prop="sample_status" width="100">
              <template v-slot="scope">
                <el-tag v-if="scope.row.sample_status === 0" size="mini" type="success">正常打样</el-tag>
                <el-tag v-else-if="scope.row.sample_status === 1" size="mini" type="danger">取消打样</el-tag>
                <el-tag v-else size="mini" type="primary">暂无</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="委托单号" prop="requ_no" />
            <el-table-column label="样品编号" prop="smpl_no" />
            <el-table-column label="更改号" prop="smpl_suffix" />
            <el-table-column label="样品名称" prop="smpl_name" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.smpl_name">
                  {{ scope.row.smpl_name }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="开版师" prop="smpl_stff_name" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.smpl_stff_name">
                  {{ scope.row.smpl_stff_name }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="样品类型" prop="smpl_type" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.smpl_type">
                  {{ scope.row.smpl_type | formatSmplType }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="样品间报价" prop="smpl_price">
              <template v-slot="scope">
                <span v-if="scope.row.smpl_price">
                  {{ scope.row.smpl_price | formaUnitPr }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="采购部核价" prop="smpl_verify_price">
              <template v-slot="scope">
                <span v-if="scope.row.smpl_verify_price">
                  {{ scope.row.smpl_verify_price | formaUnitP }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="打样数量" prop="smpl_num">
              <template v-slot="scope">
                <span v-if="scope.row.smpl_num">
                  {{ scope.row.smpl_num }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column label="打样部门" prop="belo_dept_name"></el-table-column>
            <el-table-column label="打样接收人" prop="requ_receive"></el-table-column>
            <el-table-column label="实际交样时间" prop="smpl_deil_time" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.smpl_deil_time">
                  {{ scope.row.smpl_deil_time | formatDate1 }}
                </span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column :formatter="helper.personCombina" label="录入人" prop="stff_name" show-overflow-tooltip />
            <el-table-column :formatter="formatDate" label="创建时间" prop="create_time" show-overflow-tooltip />
            <el-table-column label="委托类型">
              <template v-slot="scope">
                <el-select v-model="scope.row.smpl_quot" clearable disabled filterable placeholder="请选择委托类型" size="mini">
                  <el-option v-for="item in smplQuotList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="单据状态">
              <template v-slot="scope">
                <el-tag :type="helper.getStatusName(scope.row.status).type" size="mini"
                  >{{ helper.getStatusName(scope.row.status).name }}{{ scope.row.appr_num }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="邮寄状态" prop="smpl_ship_odd">
              <template v-slot="scope">
                <span v-if="scope.row.smpl_ship_odd === '1'">已完成</span>
                <span v-else class="vg_9f9a9a">暂无</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" prop="smpl_ship_odd">
              <template v-slot="scope">
                <el-button size="small" type="warning" @click="rework(scope.row)">重做</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="24">
          <pubPagination ref="pubPagination" :totalPage="totalPage" @changePageSearch="changePageSearch"></pubPagination>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :title="reworkTitle" :visible.sync="reworkFlag" width="40%">
      <!--<div style="display: flex">-->
      <!--  <el-select v-model="prod_processes" clearable filterable multiple placeholder="请选择(可多选)" size="small">-->
      <!--    <el-option v-for="item in processesList" :key="item" :label="item" :value="item"></el-option>-->
      <!--  </el-select>-->
      <!--  <el-button class="vg_mb_8" size="small" type="primary" @click="addRework">增加</el-button>-->
      <!--</div>-->
      <el-form ref="reworkForm" :disabled="false" :model="reworkForm" class="reworkForm" label-width="0" size="mini">
        <el-table :data="reworkForm.reworkDate.filter(x => x.destroy_flag !== 1)" border>
          <el-table-column label="序号" width="60">
            <template v-slot="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column :label-class-name="'vg_deep_red'" label="重做工序" width="auto">
            <template v-slot="scope">
              <el-form-item :prop="`reworkDate[${scope.$index}].prod_processes`" :rules="[{ required: true }]" label="重做工序">
                <el-select v-model="scope.row.prod_processes" clearable filterable multiple placeholder="请选择">
                  <el-option v-for="item in processesList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="责任人" width="auto">
            <template v-slot="scope">
              <el-select
                v-model="scope.row.respons_stff_name"
                clearable
                filterable
                placeholder="请选择"
                size="mini"
                @change="
                  val => {
                    stffTypeMap.get(val).length === 1 ? (scope.row.respons_stff_job = stffTypeMap.get(val)[0]) : '';
                    if (scope.$index === 0) {
                      c_reworkData.forEach((item, i) => {
                        if (i === 0) return;
                        item.respons_stff_name = scope.row.respons_stff_name;
                      });
                    }
                  }
                "
              >
                <el-option v-for="item in c_stffType" :key="item.stff_name" :label="item.stff_name" :value="item.stff_name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="责任人岗位" width="auto">
            <template v-slot="scope">
              <el-select
                v-model="scope.row.user_jobs"
                clearable
                filterable
                placeholder="请选择"
                size="mini"
                @change="
                  val => {
                    if (scope.$index === 0) {
                      errorChange(val, scope.row);
                      c_reworkData.forEach((item, i) => {
                        if (i === 0) return;
                        item.user_jobs = scope.row.user_jobs;
                        errorChange(val, item);
                      });
                    } else {
                      errorChange(val, scope.row);
                    }
                  }
                "
              >
                <el-option v-for="item in stffTypeMap.get(scope.row.respons_stff_name)" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="发现人" width="auto">
            <template v-slot="scope">
              <el-select
                v-model="scope.row.find_stff_name"
                clearable
                filterable
                placeholder="请选择"
                size="mini"
                @change="
                  () => {
                    if (scope.$index === 0) {
                      c_reworkData.forEach((item, i) => {
                        if (i === 0) return;
                        item.find_stff_name = scope.row.find_stff_name;
                      });
                    }
                  }
                "
              >
                <el-option v-for="item in c_stffType" :key="item.stff_name" :label="item.stff_name" :value="item.stff_name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label-class-name="'vg_deep_red'" label="出错类型" width="auto">
            <template v-slot="scope">
              <el-form-item :prop="`reworkDate[${scope.$index}].error_type`" :rules="[{ required: true }]" label="出错类型">
                <el-select
                  v-model="scope.row.error_type"
                  clearable
                  filterable
                  placeholder="请选择"
                  @change="
                    () => {
                      if (scope.$index === 0) {
                        c_reworkData.forEach((item, i) => {
                          if (i === 0) return;
                          item.error_type = scope.row.error_type;
                        });
                      }
                    }
                  "
                >
                  <el-option v-for="item in scope.row.list" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="auto">
            <template v-slot="scope">
              <el-input
                v-model="scope.row.remarks"
                maxlength="255"
                placeholder="暂无"
                show-word-limit
                type="textarea"
                @blur="
                  () => {
                    if (scope.$index === 0) {
                      c_reworkData.forEach((item, i) => {
                        if (i === 0) return;
                        item.remarks = scope.row.remarks;
                      });
                    }
                  }
                "
              ></el-input>
            </template>
          </el-table-column>
          <!--<el-table-column label="操作" width="auto">-->
          <!--  <template v-slot="scope">-->
          <!--    <el-button class="vg_mt_8" size="mini" type="danger" @click="$set(scope.row, 'destroy_flag', 1)">删除</el-button>-->
          <!--  </template>-->
          <!--</el-table-column>-->
        </el-table>
      </el-form>
      <div style="text-align: center">
        <el-button class="vg_mt_8" size="small" type="danger" @click="subRework">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, getNoCatch, post } from '@api/request';
import { smplAPI } from '@api/modules/smpl';
import pubPagination from '@/components/common/pubPagination';
import selectStatus from '@/views/component/selectStatus';
import smplListRfid from './TabChild/Componet/TabPanel/SmplListRfid.vue';
import publicTips from '@/views/component/publicTips';
import helper from '@assets/js/helper.js';
import { optnAPI } from '@api/modules/optn';
import SmplEditMail from './TabChild/SmplEditMail.vue';
import { userAPI } from '@api/modules/user';
import { requiredReminder } from '@assets/js/domUtils';
import { cloneDeep } from 'lodash';

export default {
  name: 'smplList',
  components: {
    pubPagination,
    selectStatus,
    smplListRfid,
    publicTips,
    SmplEditMail
  },
  data() {
    return {
      searchForm: {
        requ_no: null,
        smpl_name: null,
        smpl_no: null,
        smpl_type: null,
        status: null,
        belo_dept_id: null, //打样部门
        smpl_ship_odd: null,
        smpl_cust_no: null,
        smpl_stff_name: null,
        requ_receive: null,
        mtrl_sort: '',
        mtrl_field: '',
        timeValue: {
          startTime: null,
          endTime: null
        },
        timeValue1: {
          startTime: null,
          endTime: null
        },
        smpl_suffix: null
      },
      postList: [
        {
          id: 0,
          lable: '已完成',
          value: '1'
        },
        {
          id: 1,
          lable: '未完成',
          value: '0'
        }
      ],
      currentPage: 1,
      totalPage: 0,
      tableData: [],
      tableData1: [],
      tableDataList: [],
      multiSelection: [],
      btn: {},
      smplType: [
        { id: 1, label: '新款' },
        { id: 2, label: '老款' },
        { id: 3, label: '修改款' }
      ],
      loadFlag: true,
      isDyj: true,
      beloDeptId: null,
      smplFlag: false,
      title: '收件人邮箱确认',
      userInfo: {},
      deptList: [],
      smplPropList: [],
      stffType: [],
      stffTypeMap: new Map(),
      totalnum: '',
      smplQuotList: [
        { id: 1, label: '打样并报价' },
        { id: 2, label: '试样报价' },
        { id: 3, label: '仅打样' },
        { id: 4, label: '估价' },
        { id: 5, label: '返工' },
        { id: 8, label: '找料' },
        { id: 9, label: '印刷' },
        { id: 10, label: '电绣' }
      ],
      smplQuotList2: [
        { id: 1, label: '估价' },
        { id: 2, label: '仅报价' },
        { id: 3, label: '找样料' },
        { id: 4, label: '找用品' },
        { id: 5, label: '电绣/裁片' },
        { id: 6, label: '打样并报价' },
        { id: 7, label: '做文件' },
        { id: 8, label: '仅打样' }
      ],
      reworkFlag: false,
      reworkTitle: '',
      reworkDate: [],
      prod_processes: [],
      processesList: [],
      reworkRow: {},
      errorList: [],
      errorTypeList: [],
      reworkForm: { reworkDate: [] }
    };
  },
  created() {
    this.getDepartment();
  },
  mounted() {
    this.searchForm.smpl_no = this.$route.query.smpl_no;
    this.searchForm.requ_no = this.$route.query.requ_no;
    this.searchForm.smpl_suffix = this.$route.query.smpl_suffix;
    this.initData();
  },
  watch: {
    $route(to, from) {
      if (from.path === '/smpl_edit') {
        this.getSmpls();
      }
    }
    // c_reworkDataIndex0Row(newVal, oldVal) {
    //   if (!JSON.parse(oldVal)) return;
    //
    //   if (this.c_reworkData.length > 1) {
    //     const temp = cloneDeep(this.c_reworkData[0]);
    //     temp.destroy_flag = 0;
    //
    //     for (let index = 0; index < this.c_reworkData.length; index++) {
    //       if (index === 0) continue;
    //       const deep = cloneDeep(temp);
    //       deep.prod_processes = this.c_reworkData[index].prod_processes;
    //       this.$set(this.c_reworkData, index, deep);
    //     }
    //   }
    // }
  },
  computed: {
    c_stffType() {
      return this.stffType.filter(item2 => item2.dept_name === this.$cookies.get('userInfo').dept_name);
    },
    // c_reworkDataIndex0Row() {
    //   return JSON.stringify(this.reworkForm?.reworkDate[0] || null);
    // },
    c_reworkData() {
      return this.reworkForm.reworkDate.filter(x => x.destroy_flag !== 1);
    }
  },
  filters: {
    // 样品类型转换
    formatSmplType(row) {
      if (row === 1) {
        return '新款';
      } else if (row === 2) {
        return '老款';
      } else if (row === 3) {
        return '修改款';
      }
    },
    //交样时间
    formatDate1(row) {
      return helper.toTimeDay(row);
    },
    formaUnitP(row) {
      return helper.haveFour(row);
    },
    // 物料单位转换
    formaUnitPr(row) {
      return helper.haveFour(row);
    }
  },
  methods: {
    initData() {
      this.getSmpls();
      this.getOptnByPermId();
      this.getStffType();
    },
    //判断是否 是DYJ员工
    getDepartment() {
      let userInfo = this.$cookies.get('userInfo');
      if (userInfo.user_name === 'admin') {
        this.searchForm.belo_dept_id = null;
        this.isDyj = false;
        return;
      }
      if (process.env.NODE_ENV === 'production') {
        if (userInfo.dept_id === 2 || userInfo.dept_id === 17) {
          this.searchForm.belo_dept_id = userInfo.dept_id + '';
          this.beloDeptId = userInfo.dept_id + '';
          this.isDyj = true;
        } else {
          this.searchForm.belo_dept_id = null;
          this.isDyj = false;
        }
      } else {
        if (userInfo.dept_id === 2 || userInfo.dept_id === 17) {
          this.searchForm.belo_dept_id = userInfo.dept_id + '';
          this.beloDeptId = userInfo.dept_id + '';
          this.isDyj = true;
        } else {
          this.searchForm.belo_dept_id = null;
          this.isDyj = false;
        }
      }
    },
    getOptnByPermId() {
      get(optnAPI.getOptnByPermId, { perm_id: 10009 })
        .then(res => {
          if (res.data.code === 0) {
            this.userInfo = this.$cookies.get('userInfo');
            let deptList = [{ param2: null, param1: '全部' }];
            let temp = res.data.data.form.optn_cntt_list;
            let temp1 = [];
            if (process.env.NODE_ENV === 'production') {
              if (this.userInfo.dept_id === 2) {
                temp.forEach(item => {
                  if (item.param2 === '2') {
                    temp1.push(item);
                  }
                });
                this.deptList = temp1;
              } else if (this.userInfo.dept_id === 17) {
                temp.forEach(item => {
                  if (item.param2 === '17') {
                    temp1.push(item);
                  }
                });
                this.deptList = temp1;
              } else {
                this.deptList = deptList.concat(temp);
              }
            } else {
              if (this.userInfo.dept_id === 2) {
                temp.forEach(item => {
                  if (item.param2 === '2') {
                    temp1.push(item);
                  }
                });
                this.deptList = temp1;
              } else if (this.userInfo.dept_id === 17) {
                temp.forEach(item => {
                  if (item.param2 === '17') {
                    temp1.push(item);
                  }
                });
                this.deptList = temp1;
              } else {
                this.deptList = deptList.concat(temp);
              }
            }
            if (this.userInfo.user_name === 'admin') {
              temp1 = [];
              temp.forEach(item => {
                if (item.param2 === '2') {
                  temp1.push(item);
                }
                if (item.param2 === '17') {
                  temp1.push(item);
                }
              });
              this.deptList = temp1;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    // 获取产品信息
    getSmpls() {
      const timeNewVal = this.helper.getTime(this.searchForm.timeValue);
      const timeNewVal1 = this.helper.getTime(this.searchForm.timeValue1);
      get(smplAPI.getSmpls, {
        requ_no: this.searchForm.requ_no,
        smpl_no: this.searchForm.smpl_no,
        smpl_name: this.searchForm.smpl_name,
        smpl_ship_odd: this.searchForm.smpl_ship_odd,
        requ_receive: this.searchForm.requ_receive,
        smpl_type: this.searchForm.smpl_type,
        smpl_cust_no: this.searchForm.smpl_cust_no,
        smpl_stff_name: this.searchForm.smpl_stff_name,
        mtrl_sort: this.searchForm.mtrl_sort,
        mtrl_field: this.searchForm.mtrl_field,
        start_time: timeNewVal.startTime,
        end_time: timeNewVal.endTime,
        start_time1: timeNewVal1.startTime,
        end_time1: timeNewVal1.endTime,
        status: this.searchForm.status,
        page_no: this.currentPage,
        belo_dept_id: this.searchForm.belo_dept_id,
        smpl_suffix: this.searchForm.smpl_suffix
      })
        .then(res => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.totalPage = res.data.data.total;
            this.btn = res.data.data.btn;
            this.totalnum = res.data.data.smpl_num_total;
            setTimeout(() => {
              this.loadFlag = false;
            }, 500);
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },

    // 获取委托人
    getStffType() {
      getNoCatch(userAPI.getAllUsersV1).then(({ data }) => {
        let map = new Map();
        for (let item of data) {
          map.set(item.stff_name, item.user_jobs?.split(',') || []);
        }
        this.stffTypeMap = map;
        this.stffType = data;
      });
    },
    // 刷新
    buttonRefresh() {
      this.searchForm = {
        requ_no: null,
        smpl_name: '',
        smpl_ship_odd: '',
        smpl_no: '',
        smpl_type: '',
        requ_receive: null,
        status: null,
        smpl_cust_no: null,
        smpl_stff_name: null,
        smpl_suffix: null
      };
      if (this.isDyj) {
        this.searchForm.belo_dept_id = this.beloDeptId;
      } else {
        this.searchForm.belo_dept_id = null;
      }
      this.loadFlag = true;
      this.$refs.selectStatus.changeValue();
      this.currentPage = 1;
      this.getSmpls();
      this.$refs.pubPagination.currentPage = 1;
    },
    // 时间转换
    formatDate(row) {
      return this.helper.toStringDate(row.create_time);
    },
    // 查询方法
    getSmplsNow() {
      this.loadFlag = true;
      this.$refs.pubPagination.currentPage = 1;
      this.currentPage = 1;
      this.getSmpls();
    },
    // 分页查询
    changePageSearch(val) {
      this.currentPage = val;
      this.getSmpls();
    },
    // 多选
    handleSelectionChange(val) {
      this.multiSelection = val;
    },
    selectRows(selection) {
      this.btn.delete = this.helper.isDelete(selection);
    },
    // 状态查询
    getStatusVal(val) {
      this.searchForm.status = val;
    },
    //删除提示
    doDelete() {
      if (this.multiSelection.length === 0) {
        this.$message({ type: 'warning', message: '请至少选择一条数据！' });
      } else {
        let temp = false;
        for (let i = 0; i < this.multiSelection.length; i++) {
          if (this.multiSelection[i].status === 2) {
            temp = true;
            break;
          }
        }
        if (temp) {
          this.$message({ type: 'warning', message: '已生效的数据不可删除！' });
          this.$refs.multiTable.clearSelection();
        } else {
          this.mBox();
        }
      }
    },
    mBox() {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRow();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.$refs.multiTable.clearSelection();
        });
    },
    // 删除
    delRow() {
      const ids = [];
      this.multiSelection.map(item => {
        ids.push(item.smpl_id);
      });
      post(smplAPI.deleteSmplByIds, { smpl_id_list: ids })
        .then(res => {
          if (res.data.code === 0) {
            let mg = res.data.msg;
            let tp = 'success';
            this.$message({ message: mg, type: tp });
            if (ids.length === this.tableData.length) {
              if (this.currentPage > 1) {
                this.currentPage = this.currentPage - 1;
                this.$refs.pubPagination.currentPage = this.currentPage;
              }
            }
            this.getSmpls();
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
            this.getSmpls();
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //邮寄获取数据提示
    getDataPrompt() {
      if (this.multiSelection.length === 0) {
        this.$message({ type: 'warning', message: '请至少选择一条数据！' });
      } else {
        let temp = false;
        for (let i = 0; i < this.multiSelection.length; i++) {
          if (this.multiSelection[i].status != 2) {
            temp = true;
            break;
          }
        }
        if (temp) {
          this.$message({ type: 'warning', message: '未生效的数据不可更改邮寄状态！' });
          this.$refs.multiTable.clearSelection();
        } else {
          this.MailImport();
        }
      }
    },
    // 邮寄状态确认弹框
    postConfirm() {
      this.$confirm('请确认勾选的样品工单已寄出？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.changePostStatus();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
          this.$refs.multiTable.clearSelection();
        });
    },
    // 更改样单邮寄状态
    changePostStatus() {
      const ids1 = [];
      this.multiSelection.map(item => {
        ids1.push(item.smpl_id);
      });
      const ids2 = [];
      this.multiSelection.map(item => {
        ids2.push(item.requ_id);
      });
      post(smplAPI.addSmplMail, {
        requ_id_list: ids2,
        smpl_id_list: ids1
      })
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '更改成功'
            });
            this.getSmpls();
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
            this.getSmpls();
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //邮寄弹窗
    MailImport() {
      this.smplPropList = this.multiSelection;
      this.smplFlag = true;
    },
    //邮寄取消
    MailCancel() {
      this.smplFlag = false;
    },
    // 双击row跳转到详情编辑
    dbClickJp(row) {
      const permId = this.$route.query.perm_id;
      this.jump('/smpl_edit', { perm_id: permId, form_id: row.smpl_id });
    },
    //查询范围
    getStatusVal2(val) {
      this.searchForm.belo_dept_id = val;
    },
    //升序 降序
    sortChange(val) {
      if (val.order == 'ascending') {
        this.searchForm.mtrl_sort = 'asc';
        this.searchForm.mtrl_field = val.prop;
      } else if (val.order == 'descending') {
        this.searchForm.mtrl_sort = 'desc';
        this.searchForm.mtrl_field = val.prop;
      } else {
        this.searchForm.mtrl_sort = '';
        this.searchForm.mtrl_field = '';
      }
      this.searchForm.page_no = 1;
      this.initData();

      // 升序 asc
      // 降序 desc
    },
    rework(row) {
      this.getOptnByPermIdErr();
      this.processesList = [];
      this.reworkTitle = row.smpl_no + ' ' + row.requ_no;
      this.reworkFlag = true;
      this.reworkRow = row;
      this.reworkRow.rfid.forEach(item => {
        if (item.open_status !== 0) {
          this.processesList.push('开版');
        }
        if (item.stpr_status !== 0) {
          this.processesList.push('备料');
        }
        if (item.comp_status !== 0) {
          this.processesList.push('复合');
        }
        if (item.lase_status !== 0) {
          this.processesList.push('激光');
        }
        if (item.handCut_status !== 0) {
          this.processesList.push('手裁');
        }
        if (item.stam_status !== 0) {
          this.processesList.push('印花');
        }
        if (item.embr_status !== 0) {
          this.processesList.push('电绣');
        }
        if (item.emcd_status !== 0) {
          this.processesList.push('制卡');
        }
        if (item.mase_status !== 0) {
          this.processesList.push('机缝');
        }
        if (item.manu_status !== 0) {
          this.processesList.push('手工');
        }
        if (item.insp_status !== 0) {
          this.processesList.push('检验');
        }
      });
      this.reworkForm.reworkDate = [];
      this.reworkForm.reworkDate.push({
        smpl_id: this.reworkRow.smpl_id,
        prod_processes: [],
        respons_stff_name: '',
        find_stff_name: '',
        error_type: '',
        remarks: '',
        destroy_flag: 0,
        list: []
      });
      // this.$confirm('是否重做?', '提示', {
      //   confirmButtonText: '是',
      //   cancelButtonText: '否',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     const { perm_id } = this.$route.query;
      //     this.jump('/smpl_edit', { perm_id: perm_id, form_id: row.smpl_id, rework: true });
      //   })
      //   .catch(() => {});
    },
    addRework() {
      if (this.c_reworkData.length > 1) {
        this.prod_processes.forEach(item => {
          let deep = cloneDeep(this.c_reworkData[0]);
          deep.prod_processes = [item];
          this.reworkForm.reworkDate.push(deep);
        });
        this.prod_processes = [];

        return;
      }
      this.prod_processes.forEach(item => {
        this.reworkForm.reworkDate.push({
          smpl_id: this.reworkRow.smpl_id,
          prod_processes: [item],
          respons_stff_name: '',
          find_stff_name: '',
          error_type: '',
          remarks: '',
          destroy_flag: 0,
          list: []
        });
      });
      this.prod_processes = [];
    },
    subRework() {
      this.$refs.reworkForm.validate((valid, object) => {
        if (valid) {
          let item = {};
          item.smpl_id = this.reworkRow.smpl_id;
          item.stff_name = this.$cookies.get('userInfo').stff_name;
          item.sampleRedoList = this.reworkForm.reworkDate.filter(x => {
            x.prod_processes = x.prod_processes.toString();
            return x.destory_flag !== 1;
          });
          post(smplAPI.addCreateSampleRedo, item)
            .then(res => {
              if (res.data.code === 0) {
                this.initData();
                this.reworkFlag = false;
                this.reworkForm.reworkDate = [];
                this.$message.success('重做成功！');
              } else {
                this.$message.success('失败！');
              }
            })
            .catch(err => {
              this.$message.error(err);
            });
        } else {
          requiredReminder(object);
        }
      });
    },
    getOptnByPermIdErr() {
      get(optnAPI.getOptnByPermId, { perm_id: 10017 })
        .then(res => {
          if (res.data.code === 0) {
            this.errorList = res.data.data.form.optn_cntt_list;
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    errorChange(val, row) {
      row.error_type = '';
      row.list = this.errorList.find(x => x.param1 === val)?.param2?.split('/*/') || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.vd_button_group {
  // width: 100vw;
  position: relative;
}

.vd_txta {
  position: absolute;
  left: 35%;
}

::v-deep .vd_tenpd {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vd_img {
  margin-top: 5px;
  width: 40px;
}

.vd_notpass {
  color: rgb(187, 187, 187);
}

.vd_pass {
  color: #188dff;
}

.vd_complate {
  color: #36ab60;
}

.vd_disable {
  color: #d81e06;
}

.vd_wei {
  color: #ff8511;
}

.reworkBtn {
  z-index: 999;
  background: #f3941c;
  border-color: #f3941c;
}

::v-deep .reworkForm .el-form-item__label {
  display: none;
}
</style>
